export default __webpack_public_path__ + "static/media/badge_google.53c0ef0c.png";